import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

function hexToRgb(hex) {
  const cleanHex = String(hex).replace('#', '');
  const bigint = parseInt(cleanHex.length === 3
    ? cleanHex.split('').map((c) => c + c).join('')
    : cleanHex, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

function getLuminance({ r, g, b }) {
  const [rs, gs, bs] = [r, g, b].map((c) => {
    const srgb = c / 255;
    return srgb <= 0.03928 ? srgb / 12.92 : Math.pow((srgb + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

/** WCAG-friendly text class for text on dynamic hex backgrounds */
export function getContrastTextClass(bgColor) {
  if (!bgColor || typeof bgColor !== 'string') return 'text-foreground';
  let rgb;
  if (bgColor.startsWith('#')) {
    rgb = hexToRgb(bgColor);
  } else if (bgColor.startsWith('rgb')) {
    const match = bgColor.match(/\d+/g);
    if (match && match.length >= 3) {
      rgb = { r: parseInt(match[0], 10), g: parseInt(match[1], 10), b: parseInt(match[2], 10) };
    }
  }
  if (!rgb) return 'text-foreground';
  return getLuminance(rgb) > 0.179 ? 'text-gray-900' : 'text-white';
}
